module.exports = __webpack_public_path__ + "static/media/31JFA3.02e1efea.jpg";